export default function changeObjectValues(object, from, to) {
  if (from === undefined || to === undefined) {
    return object;
  }

  return JSON.parse(
    JSON.stringify(object, (key, value) => (value === from ? to : value))
  );
}
